import {useContext} from "react";

import {
    NotificationActionBubblesContext,
    type NotificationActionBubblesContextState,
} from "./context.ts";

/**
 * Hook to access notification action bubbles state/context.
 */
export const useNotificationActionBubbleState =
    (): NotificationActionBubblesContextState => {
        return useContext(NotificationActionBubblesContext);
    };
